// extracted by mini-css-extract-plugin
export var cancel = "GiftPlan-module__cancel___FyPaD";
export var card = "GiftPlan-module__card___FYGXI";
export var pickYourPlan = "GiftPlan-module__pickYourPlan___w2RBy";